import { normalizeAdminAccessCodes } from '@/entities/admin/lib/adminAccessCodes'
import { mapUtm } from '@/entities/utm/model/mapUtm'

const BACKEND_TYPE_TO_APP_ROLE = {
  user: 'client',
  courier: 'courier',
  restaurant: 'restaurant',
  admin: 'admin',
}

export function mapAuthUser(dto) {
  if (!dto) {
    return null
  }

  const type = dto.type ?? 'user'

  return {
    id: dto.id ?? null,
    firstName: dto.first_name ?? null,
    lastName: dto.last_name ?? null,
    email: dto.email ?? null,
    phoneNumber: dto.phone_number ?? null,
    defaultAddress: dto.default_address ?? null,
    defaultAddressSubtitle: dto.default_address_subtitle ?? null,
    location: dto.location ?? null,
    deliverable: typeof dto.deliverable === 'boolean' ? dto.deliverable : null,
    verified: Boolean(dto.verified),
    telegramLinked: Boolean(dto.sp_tg_linked),
    type,
    role: BACKEND_TYPE_TO_APP_ROLE[type] ?? 'client',
    sp_tg_linked: dto.sp_tg_linked ?? false,
    refCode: dto.ref_code != null && String(dto.ref_code).trim() ? String(dto.ref_code).trim() : null,
    ledgerUserId:
      dto.ledger_user_id != null && String(dto.ledger_user_id).trim()
        ? String(dto.ledger_user_id).trim()
        : null,
    accessCodes: type === 'admin' ? normalizeAdminAccessCodes(dto.access_codes) : null,
    utm: type === 'user' ? mapUtm(dto.utm) : null,
  }
}
